import { computed, inject, Injectable, Signal } from '@angular/core';
import { ApplicationType, ROUTES } from '@maia/config';
import { AuthOptions, OpenIdConfiguration, UserDataResult } from 'angular-auth-oidc-client';
import { Observable, of } from 'rxjs';
import { AppContextService } from '../services';
import { MOCK_FLAG_ON, MockStorageKey } from './mock-scenarios.const';

interface MockClaims {
  name: string;
  given_name: string;
  Title: string;
  upn: string;
  email: string;
}

const MOCK_CLAIMS: Readonly<MockClaims> = {
  name: 'Ben Entou Antaster',
  given_name: 'Ben',
  Title: 'Pedagogisch Medewerk(st)er',
  upn: 'ben.entou.antaster@partou.nl',
  email: 'ben.entou.antaster@partou.nl',
};

const MOCK_TOKEN: Readonly<string> = 'mock-access-token';

const MOCK_APPLICATIONS: Readonly<ApplicationType[]> = ['locationApp', 'workApp', 'groupApp'];

@Injectable({ providedIn: 'root' })
export class MockOidcSecurityService {
  private appContext: AppContextService = inject(AppContextService);

  public readonly userData: Signal<UserDataResult> = computed(() => ({
    userData: null,
    allUserData: MOCK_APPLICATIONS.map(configId => ({ configId, userData: MOCK_CLAIMS, errorMessage: null })),
  }));

  public isAuthenticated(_configId?: string): Observable<boolean> {
    return of(this.appContext.selectedApplication() !== null);
  }

  public authorize(configId?: string, _options?: AuthOptions): void {
    if (this.providerRejects()) {
      window.location.assign(ROUTES.forbidden);
      return;
    }
    if (configId) this.appContext.setSelectedApplication(configId as ApplicationType);
    window.location.assign(ROUTES.chat);
  }

  private providerRejects(): boolean {
    try {
      return sessionStorage.getItem(MockStorageKey.ProviderRejects) === MOCK_FLAG_ON;
    } catch {
      return false;
    }
  }

  public logoffLocal(_configId?: string): void {
    this.appContext.clear();
  }

  public getAccessToken(_configId?: string): Observable<string> {
    return of(MOCK_TOKEN);
  }

  public getIdToken(_configId?: string): Observable<string> {
    return of(MOCK_TOKEN);
  }

  public getConfigurations(): OpenIdConfiguration[] {
    return MOCK_APPLICATIONS.map(configId => ({ configId }));
  }
}
